import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { toast } from "sonner";
import api, { fileUrl } from "../lib/api";
import { useSeo } from "../lib/seo";

export default function CollectionPage() {
  const { slug } = useParams();
  const [c, setC] = useState(null);
  useSeo({ title: c ? `${c.name}${c.season_label ? ` — ${c.season_label}` : ""} Collection` : "Collection", description: c ? `${c.tagline || c.name}. ${c.description || ""} ${c.products.length} pieces: ${c.products.map((p) => p.name).join(", ")}.`.trim() : null, path: `/collections/${slug}` });
  useEffect(() => { api.get(`/collections/${slug}`).then((r) => setC(r.data)).catch(() => toast.error("Collection not found")); }, [slug]);
  if (!c) return <div className="max-w-7xl mx-auto px-6 py-24 text-[#4a4a4a]">Loading…</div>;
  const banner = c.banner_image?.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${c.banner_image}` : c.banner_image;

  return (
    <div data-testid="collection-page">
      <section className="relative bg-[#0a192f] text-white overflow-hidden min-h-[380px] flex items-end">
        {banner && <img src={banner} alt="" className="absolute inset-0 w-full h-full object-cover opacity-45" />}
        <div className="absolute inset-0 bg-gradient-to-t from-[#0a192f] via-[#0a192f]/60 to-transparent" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-10 py-16 w-full">
          {c.season_label && <div className="overline text-[#d4af37]" data-testid="collection-season">{c.season_label}</div>}
          <h1 data-testid="collection-title" className="font-serif text-5xl lg:text-6xl mt-3 tracking-tight">{c.name}</h1>
          {c.tagline && <p className="text-white/80 text-lg mt-4 max-w-2xl">{c.tagline}</p>}
        </div>
      </section>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
        {c.description && <p className="text-[#1a1a1a] leading-relaxed max-w-3xl whitespace-pre-line mb-12">{c.description}</p>}
        {c.products.length === 0 ? (
          <div className="card-flat p-16 text-center font-serif text-2xl text-[#0a192f]">Pieces arriving soon.</div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {c.products.map((p) => (
              <Link key={p.id} to={`/product/${p.id}`} data-testid={`collection-product-${p.id}`} className="prod-card card-flat group block">
                <div className="aspect-[4/5] bg-[#f4f5f7] overflow-hidden">
                  {p.cover_key ? <img src={fileUrl(p.cover_key)} alt={p.name} loading="lazy" className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-500" /> : <div className="w-full h-full flex items-center justify-center font-serif text-3xl text-[#4a4a4a]">{p.name?.[0]}</div>}
                </div>
                <div className="p-5">
                  <div className="overline text-[#4a4a4a]">{p.category}</div>
                  <div className="font-serif text-2xl text-[#0a192f] mt-2 leading-tight">{p.name}</div>
                  <div className="mt-4 font-semibold text-[#0a192f]">${(p.price_cents / 100).toFixed(2)}</div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
